import angular from 'angular';
import menuFamilyNeedALoanComponent from './menuFamilyNeedALoan.component';

let menuFamilyNeedALoanModule = angular.module('menuFamilyNeedALoan', [
])

.component('menuFamilyNeedALoan', menuFamilyNeedALoanComponent)

.name;

export default menuFamilyNeedALoanModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/needALoan/menuFamilyNeedALoan/menuFamilyNeedALoan.js